<template>
  <font-awesome-icon :icon="['fas', 'shopping-cart']" size="1x" :class="clazz" @click="$emit('toggle')"/>
</template>
<script>
export default {
  props: {
    article: Object
  },
  data() {
    return {
      selectableArticles: []
    }
  },
  computed: {
    inSale(){
      return this.article?.inSale
    },
    icon() {
      if(this.inSale)
        return 'shop'
      return 'shop-slash'
    },
    clazz(){
      if(this.inSale)
        return 'text-success'
      return 'text-light'
    }
  }
}
</script>
